import {useEffect, useState} from 'react';
import {Box, Slider, SliderProps, SliderThumb} from '@mui/material';
import ThumbComponentIcon  from 'shared/assets/icons/range_slider.svg';
import styles from './slider-range-input.module.scss';

interface SliderInputProps extends SliderProps {
  symbol?: string;
  max?: number;
  defaultValue?: [number, number];
  value: any;
}
interface ThumbComponentProps extends React.HTMLAttributes<unknown> {}

export const SliderRangeInput = ({title, min, max, symbol, defaultValue, value, ...props}:SliderInputProps) => {
  // const [value, setValue] = useState<any>(defaultValue);
  const [firstValueText, setFirstValue] = useState<any>(`${new Intl.NumberFormat('ru-RU').format(min as number)} ${symbol}`);
  const [secondValueText, setSecondValue] = useState<any>(`${new Intl.NumberFormat('ru-RU').format(max as number)} ${symbol}`);

  // const handleSliderChange = (event: Event, newValue:any) => {
  //   setValue(newValue as any);
  // };

  function ThumbComponent(props: ThumbComponentProps) {
    const { children, ...other } = props;
    return (
      <SliderThumb {...other}>
        {children}
        <ThumbComponentIcon />
      </SliderThumb>
    );
  }

  useEffect(() => {
    setFirstValue(`${new Intl.NumberFormat('ru-RU').format(value[0] as number)} ${symbol}`);
    setSecondValue(`${new Intl.NumberFormat('ru-RU').format(value[1] as number)} ${symbol}`);
  }, [value]);

  // const valueTitle = () => {
  //   return `${new Intl.NumberFormat('ru-RU').format(value[0] as number)} ${symbol} - ${new Intl.NumberFormat('ru-RU').format(value[1] as number)} ${symbol}`
  // }


  return (
    <Box className={styles.sliderWrapper}>
      <span className={styles.titleUp}>
        {title}
      </span>
      <span className={styles.valueTitle}>
        {firstValueText} - {secondValueText}
      </span>
      <Box className={styles.sliderContainer}>
        <Slider
          className={styles.sliderCustom}
          // onChange={handleSliderChange}
          slots={{ thumb: ThumbComponent }}
          value={value}
          sx={{
            '.MuiSlider-mark': {
              display: 'none',
            },
            '.MuiSlider-markLabel': {
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: '5px',
              letterSpacing: '0.02em',
              color: '#96A8B8',
              '&:nth-of-type(4)': {
                left: '4%!important',
              },
              '&:nth-of-type(6)': {
                left: '95%!important',
              },
            },
            '.MuiSlider-thumb': {
              width: '16px',
              height: '16px',
              backgroundColor: 'unset',
              '&:after': {
                content: 'none',
              },
              '&:before': {
                content: 'none',
              },
              '&:hover': {
                boxShadow: 'none',
              },
              '&:focus': {

              },
              '&.Mui-focused':{
                boxShadow: 'none',
              },
              '&.Mui-focusVisible':{
                boxShadow: 'none',
              },
              '&:active': {
                boxShadow: 'none',
              }
            },
            '.MuiSlider-rail': {
              height: '2px',
              backgroundColor: '#B5D4F9',
              borderRadius: 0,
            },
            '.MuiSlider-track': {
              height: '2px',
              backgroundColor: '#4794EF',
              border: 'none',
              borderRadius: 0,
            },
          }}
          {...props}
          min={min}
          max={max}
        />
      </Box>
    </Box>
  );
};
